import styled from 'styled-components';
import { Dialog } from '@scope/scope-one-ui/core';
import { COLORS, SIZES } from '@scope/scope-one-ui/theme';

export const Modal = styled(Dialog)`
  width: 70vw;
  max-width: ${SIZES.spacing(160)};
`;

export const Dot = styled.div`
  background-color: ${COLORS.typography.label};
  width: ${SIZES.spacing(1)};
  height: ${SIZES.spacing(1)};
  border-radius: 50%;
`;
